import { ISubmissionPublicationPagedRequest } from '../../../../model/sep/submission-publications/request/submission-publication-paged-request';
import { IUserSendSubmissionPublicationResponse } from '../../../../model/sep/submission-publications/response/user-send-submission-publication-response';
import { IStatusSubmissionPublicationResponse } from '../../../../model/sep/submission-publications/response/status-submission-publication-response';

export type SubmissionPublicationSearchState = {
  users: IUserSendSubmissionPublicationResponse[];
  status: IStatusSubmissionPublicationResponse[];
  parameters: ISubmissionPublicationPagedRequest;
  searchTrigger: number;
};

export enum ACTION_TYPES {
  setLookups = 'setLookups',
  updateParameter = 'updateParameter',
  triggerSearch = 'triggerSearch',
}

export const SubmissionPublicationSearchReducer = (state: SubmissionPublicationSearchState, action: any): SubmissionPublicationSearchState => {
  const { type, payload } = action;
  switch (type) {
    case ACTION_TYPES.setLookups:
      return {
        ...state,
        users: payload.users,
        status: payload.status,
      };
    case ACTION_TYPES.updateParameter:
      return {
        ...state,
        parameters: {
          ...state.parameters,
          ...payload,
        },
      };
    case ACTION_TYPES.triggerSearch:
      return {
        ...state,
        searchTrigger: state.searchTrigger + 1,
      };
    default:
      throw new Error(`Unhandled action type: ${type}`);
  }
}
